import { action, computed } from "@ember/object"
import { isValidUrl, withProtocol } from "@shared/lib/urls"
import Component from "@glimmer/component"

interface Options {
  url: string | null
  title: string | null
  allowEmptyUrl?: boolean
}

interface Sig {
  Args: {
    options: Options
    accept: (result: {
      url: string
      /** The title input by the user, or url if that was blank. */
      title: string
      /** The actual title input by the user (possibly ""). */
      inputTitle: string
    }) => void
    decline: () => void
  }
}

export default class LinkAsAttachment extends Component<Sig> {
  @computed("_validityInner")
  get validity(): "empty" | "valid" | "invalid" {
    const inner = this._validityInner
    if (this.args.options.allowEmptyUrl && inner === "empty") return "valid"
    else return inner
  }

  @computed("args.options.url")
  get _validityInner(): "empty" | "valid" | "invalid" {
    const rawUrl = this.args.options.url
    if (rawUrl === null) return "empty"

    const url = rawUrl.trim()
    if (url === "") return "empty"

    return isValidUrl(url) ? "valid" : "invalid"
  }

  @action
  doAccept() {
    if (this.validity !== "valid") return

    let url = this.args.options.url?.trim() ?? ""
    const title = this.args.options.title || url
    if (url !== "") url = withProtocol(url)
    this.args.accept({ url, title, inputTitle: this.args.options.title || "" })
  }

  @action
  onKeydown(event: KeyboardEvent) {
    if (event.key === "Enter") {
      event.stopPropagation()
      this.doAccept()
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Dialogs::LinkAsAttachment": LinkAsAttachment
  }
}
